import { useState, useEffect } from "react";
import "./newProduct.css";
import { addProduct } from "../../redux/apiCalls";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { publicRequest } from "../../requestMethods";
import { useHistory } from "react-router-dom";

export default function NewProduct() {
    const [inputs, setInputs] = useState({});
    const dispatch = useDispatch();
    const history = useHistory();
    const [categories, setCategories] = useState([]);
    const [principles, setPrinciples] = useState([]);
    
    const superadmin = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.isSuperAdmin === true : null
    );

    // Redirect if not superadmin
    useEffect(() => {
        if (superadmin === false) {
            history.push("/");
        }
    }, [superadmin, history]);

    const getAllCategories = async () => {
        const res = await publicRequest.get("/category/all", {
            params: { isAdmin: true },
        });
        setCategories(res.data);
    };

    const getAllPrinciples = async () => {
        try {
            const params = {
                type: ["outright"],
            };

            const res = await publicRequest.get("/users/admin", {
                params,
            });
            setPrinciples(res.data);
        } catch (err) {
            console.error("Error fetching principles:", err);
        }
    };

    useEffect(() => {
        if (categories.length === 0) {
            getAllCategories();
        }
        if (principles.length === 0) {
            getAllPrinciples();
        }
    }, [categories, principles]);

    const handleChange = (e) => {
        setInputs((prev) => {
            return { ...prev, [e.target.name]: e.target.value };
        });
    };

    const handleCategoryChange = (e) => {
        setInputs((prev) => {
            return { ...prev, category: e.value };
        });
    };

    const handlePrincipleChange = (e) => {
        setInputs((prev) => {
            return { ...prev, principle: e.value };
        });
    };

    const handleClick = async () => {
        if (!inputs.title) {
            alert("Please enter a product title");
            return;
        }
        if (!inputs.category) {
            alert("Please select a category");
            return;
        }
        
        const product = {
            ...inputs,
        };
        addProduct(product, dispatch);
    };

    if (!superadmin) {
        return null;
    }

    return (
        <div className="newProduct">
            <h1 className="addProductTitle">New Product</h1>
            <div className="addProductForm">
                <div className="addProductItem">
                    <label>Product Title *</label>
                    <input
                        name="title"
                        type="text"
                        placeholder="Product Title"
                        onChange={handleChange}
                    />
                </div>

                <div className="addProductItem">
                    <label>Category *</label>
                    <Select
                        options={categories.map((category, i) => {
                            return { label: category.title, value: category._id };
                        })}
                        onChange={handleCategoryChange}
                        placeholder="Select Category"
                    />
                </div>

                <div className="addProductItem">
                    <label>Item Code</label>
                    <input
                        name="itemCode"
                        type="text"
                        placeholder="Item Code"
                        onChange={handleChange}
                    />
                </div>

                <div className="addProductItem">
                    <label>Principle</label>
                    <Select
                        options={principles.map((user, i) => {
                            return { label: user.name || user.email, value: user._id };
                        })}
                        onChange={handlePrincipleChange}
                        placeholder="Select Principle (Optional)"
                        isClearable
                    />
                </div>

                <div className="addProductItem">
                    <label>Minimum Price (Optional)</label>
                    <input
                        name="minimumPrice"
                        type="number"
                        placeholder="Minimum Price"
                        onChange={handleChange}
                    />
                </div>

                <button onClick={handleClick} className="addProductButton formCreateButton">
                    Create
                </button>
            </div>
        </div>
    );
}
